export class Loc {
  constructor(
    public lat: number,
    public lon: number,
    public altitude: number
  ) {}

  // Calculates the haversine distance based on: https://www.movable-type.co.uk/scripts/latlong.html
  distance(to: Loc) {
    const R = 6371e3; // metres
    const φ1 = (this.lat * Math.PI) / 180; // φ, λ in radians
    const φ2 = (to.lat * Math.PI) / 180;
    const Δφ = ((to.lat - this.lat) * Math.PI) / 180;
    const Δλ = ((to.lon - this.lon) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // in metres
  }
}
